export interface ContextBuffer {
  usedTokens: number;
  freeTokens: number;
  totalTokens: number;
  usagePercent: number;
}

// The backend sets `context_buffer` on the agent state at the end of each run.
// Returns null until tokens have actually been sent, so the meter stays hidden.
export function parseContextBuffer(state: unknown): ContextBuffer | null {
  if (typeof state !== "object" || state === null) return null;
  const cb = (state as { context_buffer?: unknown }).context_buffer;
  if (typeof cb !== "object" || cb === null) return null;

  const { used_tokens, free_tokens } = cb as { used_tokens?: unknown; free_tokens?: unknown };
  if (typeof used_tokens !== "number" || typeof free_tokens !== "number") return null;

  // No tokens sent yet: nothing meaningful to show.
  if (used_tokens <= 0) return null;

  const total = used_tokens + free_tokens;
  return {
    usedTokens: used_tokens,
    freeTokens: free_tokens,
    totalTokens: total,
    usagePercent: total > 0 ? (used_tokens / total) * 100 : 0,
  };
}
